import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../api";
import type { Datified, Schemas } from "../../api/types";
import { qs } from "./query";

export type AresSubject = Schemas["AresSubject"];
export type AresHit = Schemas["AresHit"];
export type VatPayerStatus = Datified<Schemas["VatPayerStatus"], "checked_at">;

export function lookupAres(ico: string): Promise<AresSubject> {
  return apiGet<AresSubject>(`/registry/ares/${encodeURIComponent(ico)}`);
}

export async function searchAres(q: string): Promise<AresHit[]> {
  return (await apiGet<{ items: AresHit[] }>(`/registry/ares${qs({ q, limit: 10 })}`)).items;
}

/** The VAT payer register's view of a DIČ (unreliable payer, accounts). */
export function useVatPayerStatus(dic: string | undefined) {
  const valid = !!dic && /^(CZ)?\d{8,10}$/i.test(dic.replace(/\s/g, ""));
  return useQuery<VatPayerStatus>({
    queryKey: ["registry", "vat", dic],
    queryFn: () => apiGet<VatPayerStatus>(`/registry/vat-payers/${encodeURIComponent(dic!.replace(/\s/g, ""))}`),
    enabled: valid,
    staleTime: 15 * 60_000,
    retry: false,
    meta: { suppressErrorToast: true },
  });
}
